module.exports = __webpack_public_path__ + "static/media/git_lab_logo.5b9e97ba.svg";